export default import.meta.ROLLDOWN_FILE_URL_6S8MoEkuVBBJJ3mmGTNGcA